<template>
  <footer :class="{ 'footer-expanded': showFooterDetail }">
    <div class="footer-content">
      <div class="footer-detail" v-if="showFooterDetail">
        <div class="detail-content">
          <img
            src="@/assets/mastermind-white-logo.svg"
            alt="Mastermind logo"
            class="w-48 h-auto pt-4"
          />
          <p class="mt-5">{{ appName }}</p>
          <address>
            <p>1320 Illinois Rte 59</p>
            <p>Naperville, IL</p>
            <p>60563</p>
          </address>
          <div class="mt-2 md:hidden">
            <template v-for="label in labels" :key="label.title">
              <router-link
                v-if="!label.isExternal"
                :to="{ name: isLogged ? label.route : label.standaloneRoute }"
                class="mt-3 underline block"
              >
                {{ label.title }}
              </router-link>
              <a
                v-else
                :href="label.link"
                target="_blank"
                class="mt-3 underline block"
                >{{ label.title }}
              </a>
            </template>
          </div>
        </div>
      </div>
      <div class="footer-bar flex justify-between px-4 py-2 text-white">
        <div>
          <em
            v-if="!showFooterDetail"
            @click="changeFooterVisibility()"
            class="fa-solid fa-chevron-up md:hidden cursor-pointer"
          ></em>
          <em
            v-else
            @click="changeFooterVisibility()"
            class="fa-solid fa-chevron-down md:hidden cursor-pointer"
          ></em>
          <em class="ml-5 fa-regular fa-copyright"></em>
          <span class="ml-2 text-sm md:text-base">
            {{ new Date().getFullYear() }} {{ appName }}. All rights reserved.
          </span>
        </div>
        <div class="hidden md:block mr-5">
          <template v-for="label in labels" :key="label.title">
            <router-link
              v-if="!label.isExternal"
              :to="{ name: isLogged ? label.route : label.standaloneRoute }"
              class="mx-4 underline"
              >{{ label.title }}</router-link
            >
            <a
              v-else
              :href="label.link"
              target="_blank"
              class="mx-4 underline"
              >{{ label.title }}</a
            >
          </template>
          <em
            v-if="!showFooterDetail"
            @click="changeFooterVisibility()"
            class="mx-2 fa-solid fa-chevron-up cursor-pointer"
          ></em>
          <em
            v-else
            @click="changeFooterVisibility()"
            class="mx-2 fa-solid fa-chevron-down cursor-pointer"
          ></em>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { computed, ref } from "vue";
import { useStore } from "vuex";

const store = useStore();
const isLogged = computed(() => store.getters["user/getUserIsLogged"]);

const showFooterDetail = ref(false);
const labels = ref([
  {
    title: "Quick Start Guide",
    route: "Quick Start Guide",
    standaloneRoute: "Standalone Quick Start Guide",
    isExternal: false,
  },
  {
    title: "Training Program",
    route: "Training Program",
    standaloneRoute: "Standalone Training Program",
    isExternal: false,
  },
  {
    title: "Assessment Overview",
    route: "Assessment Overview",
    standaloneRoute: "Standalone Assessment Overview",
    isExternal: false,
  },
  // {
  //   title: "Contact Us",
  //   link: "https://www.mastermindsports.com/contact-us",
  //   isExternal: true,
  // },
  {
    title: "Privacy Policy",
    route: "Privacy Policy",
    standaloneRoute: "Standalone Privacy Policy",
    isExternal: false,
  },
  {
    title: "Terms of Service",
    route: "Terms of Service",
    standaloneRoute: "Standalone Terms of Service",
    isExternal: false,
  },
]);

function changeFooterVisibility() {
  showFooterDetail.value = !showFooterDetail.value;
}

const appName = computed(() => store.getters["location/getAppName"]);
</script>

<style scoped>
footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 50;
  transition: transform 0.3s ease;
}

.footer-content {
  background-color: #111c2e;
  position: relative;
  width: 100%;
}

.footer-detail {
  background-color: #111c2e;
  color: white;
  position: absolute;
  bottom: 100%;
  left: 0;
  right: 0;
  transform: translateY(100%);
  transition: transform 0.3s ease;
}

.detail-content {
  padding: 1rem 1.5rem;
}

.footer-bar {
  background-color: #111c2e;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

@media (max-width: 767px) {
  .footer-expanded .footer-detail {
    transform: translateY(0);
  }
}

@media (min-width: 768px) {
  .detail-content {
    padding: 1.5rem 3rem;
  }

  .footer-detail {
    opacity: 0;
    visibility: hidden;
    transition: transform 0.3s ease, opacity 0.3s ease, visibility 0.3s;
  }

  .footer-expanded .footer-detail {
    transform: translateY(0);
    opacity: 1;
    visibility: visible;
  }
}

@media (prefers-reduced-motion: reduce) {
  footer,
  .footer-detail {
    transition: none;
  }
}
</style>
